export function get15DigitId(id: string) {
  return id.slice(0, 15);
}

export function isSfIdMatching(id1: string, id2: string) {
  return get15DigitId(id1) === get15DigitId(id2);
}
